import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import VideoDrawer from '@blade/common/components/task-management/simple-drawer.vue';
import RoiDataItem from './roi-data-item.vue';
import DrawRoiMap from './draw-roi-map.vue';
import DrawMapMap from './roi-map-item.vue';
import mapUtil from '@blade/common-ui/map-old/2d/src/components/drawer-map/index.vue';
import { mapQuery, taskDetail } from '@blade-sxp/task-management/api/statistics/index';
import MapDarwer from './map-darwer-change.vue';
import { setCustomOptions } from '@blade-sxp/task-management/constant/drawer-options';
import { cloneDeep, isEmpty } from 'lodash';
// import { addLabel } from '@blade-sxp/map/utils/index';
import MapDeviceIcon from './device.vue';
import MapPersonIcon from './person.vue';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
// const MAP_UTILS = {
//   addLabel,
// };
let RoiArea = class RoiArea extends Vue {
    rtspUrl;
    roiType;
    drawState;
    activeTask;
    currentZoneDetail = {};
    // @Prop({ default: 'roiArea' }) readonly activeTab!:string;
    // @Prop({ default: 'roiArea' }) readonly drawButtons!:any;
    dataSource;
    mapSource;
    zoneId;
    twinRoi;
    slectValue;
    roiDisabled;
    zoneList = [];
    showMapDarwer = false;
    localDrawState = false;
    showMapRoi = true;
    showBottomText = false;
    isPlay = true;
    showMap = false;
    showMapChange = false;
    polygonsList;
    // personList: Person[] = [];
    personList = [];
    deviceList = [];
    complete = false;
    verticesList = [];
    isDragPerson = false;
    mode = 'normal';
    personVertices = {};
    // personVertices: Vertices = {};
    limits = {};
    isPlayFlag = false;
    specifiedStyle = {
        width: 748,
        height: 415,
    };
    styleProp = {
        width: 400,
        height: 350,
    };
    placeholder = '';
    options = setCustomOptions('polygon');
    polygons = [];
    paintState = false;
    visibleMap = false;
    drawButtons;
    videoPlayStatus = false;
    showPoints = false;
    selectActive = -1;
    mapConfig = { configJson: '' };
    onchangeRtspUrl(val, oldVal) {
        if (oldVal) {
            const dom = this.$refs.drawer?.$refs.simpleDrawer;
            dom.handleClear();
            this.videoPlayStatus = false;
            this.paintState = false;
            this.polygonsList = [];
            this.polygons = [];
            this.$emit('polygon-list-data', this.polygons);
        }
    }
    changeZoneList(val) {
        this.zoneListLinked();
    }
    activeTabChange(val) {
        this.isPlay = true;
        this.showBottomText = false;
        this.showPoints = false;
        if (val === 'roiArea') {
            this.drawButtons = ['polygon'];
            this.options = setCustomOptions('polygon');
            this.specifiedStyle = {
                width: 748,
                height: 415,
            };
            this.placeholder = this.$t('roiAreaText');
        }
        if (val === 'lines') {
            this.drawButtons = ['lines'];
            this.options = setCustomOptions('line');
            this.specifiedStyle = {
                width: 748,
                height: 415,
            };
            this.placeholder = this.$t('lineText');
        }
        if (val === 'bodyFrame') {
            this.$refs.drawer.$refs.simpleDrawer.handleClear();
            this.drawButtons = ['rect'];
            this.options = setCustomOptions('rect');
            this.specifiedStyle = {
                width: 748,
                height: 415,
            };
            this.placeholder = this.$t('frameText');
        }
        if (val === 'markOnMap') {
            this.drawButtons = ['polygon'];
            this.specifiedStyle = {
                width: 560,
                height: 315,
            };
            this.options = setCustomOptions('polygon');
            this.showPoints = true;
        }
        // 暂时折磨写
        if (val === 'modelType') {
            this.drawButtons = ['unknown'];
        }
        if (this.drawButtons && this.drawButtons.length > 0) {
            this.setData(this.drawButtons[0], this.dataSource);
            this.paintState = false;
        }
    }
    activeTaskChange(val) {
        if (val === 'queue') {
            this.limits = { polygon: 1, lines: 1 };
        }
        if (val === 'staffLeave') {
            this.limits = { polygon: 1 };
        }
    }
    changeComplete(val) {
        this.$emit('changeComplete', val);
    }
    mounted() {
        if (this.activeTask === 'queue') {
            if (this.mapSource.length > 0) {
                this.complete = true;
            }
        }
        this.getMapQuery();
    }
    changeMode() {
        this.mode = 'normal';
    }
    getDeviceDom(status, deviceId) {
        const container = [
            {
                vueConfig: {
                    instance: MapDeviceIcon,
                    data: {
                        status: status,
                        deviceId: deviceId,
                    },
                    emitMethods: {},
                },
            },
        ];
        return container;
    }
    getPersonDom(status, personId) {
        const container = [
            {
                vueConfig: {
                    instance: MapPersonIcon,
                    data: {
                        status: status,
                        personId: personId,
                    },
                    emitMethods: {
                        onClickPerson: this.clickPerson,
                    },
                },
            },
        ];
        // const container = MAP_UTILS.addLabel(
        //   MapPersonIcon,
        //   {
        //     propsData: {
        //       status: status,
        //       personId: personId,
        //     },
        //   },
        //   {
        //     onClickPerson: this.clickPerson,
        //   }
        // );
        return container;
    }
    getMapQuery() {
        this.personList = [];
        if (this.zoneId) {
            this.showMap = true;
            this.verticesList = [];
            this.deviceList = [];
            mapQuery(this.zoneId)
                .then((res) => {
                this.currentZoneDetail = res;
                this.mapConfig = res.mapConfig;
                // 离岗小人
                if (this.twinRoi?.x && this.twinRoi?.y && this.activeTask === 'staffLeave') {
                    this.complete = true;
                    let verticesToAdd = this.twinRoi;
                    this.personVertices = this.twinRoi;
                    this.verticesList.push(verticesToAdd);
                    this.resetPersonList();
                }
                // 排队设备
                if (this.twinRoi?.x && this.twinRoi?.y && this.activeTask === 'queue') {
                    const deviceDom = this.getDeviceDom('ONLINE', '1');
                    let device = {
                        id: 'QUEUE',
                        vertices: this.twinRoi,
                        dom: deviceDom,
                        visible: true,
                        vueConfig: {
                            instance: MapDeviceIcon,
                            data: {
                                status: 'ONLINE',
                                deviceId: '1',
                            },
                        },
                    };
                    this.deviceList.push(device);
                }
            })
                .finally(() => {
                this.showMap = false;
            });
        }
    }
    handleDrawEnd(val) {
        // 绘制完成关闭绘制状态
        this.showBottomText = false;
        this.isPlay = true;
        this.paintState = false;
        let temporaryData = [];
        let dom = this.$refs.drawer?.$refs.simpleDrawer;
        if (!isEmpty(val)) {
            val.forEach((item) => {
                const { vertices, id } = item;
                const len = vertices?.length;
                if (len > 10) {
                    this.$nextTick(() => {
                        dom?.deleteGraph(id);
                    });
                    this.$message.error(`${this.$t('mostRoi')}`);
                }
                else {
                    temporaryData.push(item);
                    this.polygonsList = temporaryData;
                    this.setData(this.drawButtons[0], this.polygonsList);
                    this.$emit('polygon-list-data', temporaryData);
                }
            });
        }
        else {
            this.polygonsList = val;
            this.setData(this.drawButtons[0], this.polygonsList);
            this.$emit('polygon-list-data', val);
        }
        dom = null;
    }
    noSelectDirection(e) {
        let lines;
        lines = e.find((item) => {
            return item.type === 'lines';
        });
        this.$emit('noSelectDirection', lines?.id);
    }
    drawend(e) {
        this.paintState = false;
        this.$emit('getMapPolygonData', e);
        if (e) {
            if (e.length > 0) {
                this.complete = true;
            }
            else {
                this.complete = false;
            }
        }
    }
    setStartDraw(val) {
        if (this.roiType === 'bodyFrame') {
            this.isPlay = false;
        }
        this.paintState = true;
        this.showBottomText = true;
    }
    setData(type, val) {
        this.polygons = [];
        if (val) {
            for (let value of val) {
                if (value.type === type) {
                    this.polygons.push(value);
                }
            }
        }
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    deleteRoiArea(id) {
        const param = {
            mapId: id,
            reovemId: this.taskId() + id,
        };
        MapPolygonsModule.removeMapPolygonMap(param);
        MapPolygonsModule.removeTemporarySaveData(param);
        const dom = this.$refs.drawer;
        dom.$refs.simpleDrawer.deleteGraph(id);
    }
    setRoiMap(val) {
        this.visibleMap = val;
    }
    closeDrawRoiMap() {
        this.visibleMap = false;
    }
    setRoiBadyMap() {
        this.mode = 'mark';
        if (this.activeTask === 'staffLeave') {
            this.mode = 'mark';
            if (this.verticesList.length > 0) {
                this.personList = [];
                this.verticesList = [];
                this.onRemovePerson();
                this.complete = false;
            }
            else {
                let verticesToAdd;
                this.complete = true;
                verticesToAdd = { x: +Math.random().toPrecision(4), y: +Math.random().toPrecision(4), z: 0 };
                this.personVertices = verticesToAdd;
                this.verticesList.push(verticesToAdd);
                // let person = {
                //   id: '1',
                //   status: 'ONLINE',
                //   type: 'ONLINE',
                // };
                // this.markPersosn({ verticesToAdd, person });
            }
        }
        if (this.activeTask === 'queue') {
            if (this.complete) {
                this.$confirm(`${this.$t('roiTip')}`, `${this.$t('tip')}`, {
                    confirmButtonText: `${this.$t('confirm')}`,
                    cancelButtonText: `${this.$t('cancel')}`,
                    cancelButtonClass: 'cancel-roi-tip',
                    confirmButtonClass: 'confirm-roi-tip',
                    type: 'warning',
                })
                    .then(() => {
                    this.$emit('delectMapSource', []);
                    this.complete = false;
                    this.paintState = false;
                    this.mode = 'mark';
                })
                    .catch(() => { });
            }
            else {
                this.paintState = true;
            }
        }
    }
    async markPersosn({ verticesToAdd, person }) {
        this.personVertices = verticesToAdd;
        this.resetPersonList();
        this.$emit('mapAddDevice', verticesToAdd);
    }
    onRemovePerson() {
        this.$emit('mapAddDevice', '');
    }
    resetPersonList() {
        this.personList = [];
        const personDom = this.getPersonDom('ONLINE', '1');
        // let personObj = {
        //   id: '1',
        //   status: 'ONLINE',
        //   visible: true,
        //   vertices: this.personVertices,
        //   type: 'ONLINE',
        //   dom: personDom,
        // };
        let personObj = {
            id: 'OFF_DUTY_DETECTION',
            vertices: this.personVertices,
            dom: personDom,
            visible: true,
            vueConfig: {
                instance: MapPersonIcon,
                data: {
                    status: 'ONLINE',
                    personId: '1',
                },
                emitMethods: {
                    onClickPerson: this.clickPerson,
                },
            },
        };
        this.personList.push(personObj);
    }
    async markDevice({ verticesToAdd, device }) {
        // await this.init(device);
        this.personVertices = verticesToAdd;
        this.$emit('mapAddDevice', verticesToAdd);
    }
    clickDevice(device) { }
    clickPerson() {
        const targetPerson = this.personList[0];
        this.isDragPerson = true;
        this.$set(targetPerson, 'visible', false);
    }
    drawPersonPosition(relativePosition) {
        if (!relativePosition)
            return;
        let person = {
            id: '1',
            status: 'ONLINE',
            type: 'ONLINE',
        };
        if (this.complete && !this.personList.length) {
            this.markPersosn({ verticesToAdd: relativePosition, person });
        }
        if (this.isDragPerson) {
            const targetPerson = this.personList[0];
            this.$set(targetPerson, 'vertices', relativePosition);
            this.$set(targetPerson, 'visible', true);
            this.$emit('mapAddDevice', relativePosition);
            this.isDragPerson = false;
        }
    }
    // 视频ROI转化地图roi
    formatPolygons(val) {
        const dom = document.querySelector('.map');
        const rectInfor = dom.getBoundingClientRect();
        const offSetLeft = rectInfor.left;
        const offSetTop = rectInfor.top;
        const h = this.styleProp.height;
        const w = this.styleProp.width;
        let newVertices = [];
        if (h && w && val) {
            newVertices = cloneDeep(val).map((item) => {
                return {
                    x: Number(item.x) * w + offSetLeft,
                    y: Number(item.y) * h + offSetTop,
                };
            });
            return newVertices;
        }
    }
    zoneListLinked() {
        if (this.slectValue) {
            this.getTaskDetail();
        }
        else {
            this.showMapRoi = false;
            this.zoneList = [];
            // this.resetPersonList();
            this.$nextTick(() => {
                this.showMapRoi = true;
            });
        }
    }
    getTaskDetail() {
        this.showMapRoi = false;
        if (this.slectValue) {
            taskDetail(this.slectValue).then((res) => {
                let obj = JSON.parse(res.deviceTaskConfigs[0].roiData).mapSourceData[0];
                this.zoneList = [];
                if (obj?.type === 'roi3d') {
                    this.zoneList.push({
                        id: res?.id,
                        vertices: obj.vertices,
                        type: 'roi3d',
                    });
                }
                else {
                    this.zoneList.push({
                        id: res?.id,
                        vertices: obj.vertices,
                        title: res.name,
                    });
                }
                this.showMapRoi = true;
                // this.resetPersonList();
            });
        }
    }
    getMapRoi(val) {
        this.$emit('map-roi-polyons', val);
    }
    getPlaybackStatus(val) {
        this.videoPlayStatus = val;
    }
    onChangePaintState(val) {
        this.selectActive = val ? 0 : -1; // 目前只有会有一个roi，依据选中状态切换选中的图
    }
};
__decorate([
    Prop({ default: '' })
], RoiArea.prototype, "rtspUrl", void 0);
__decorate([
    Prop({ default: 'roiArea' })
], RoiArea.prototype, "roiType", void 0);
__decorate([
    Prop({ default: false })
], RoiArea.prototype, "drawState", void 0);
__decorate([
    Prop({ default: '' })
], RoiArea.prototype, "activeTask", void 0);
__decorate([
    Prop()
], RoiArea.prototype, "dataSource", void 0);
__decorate([
    Prop()
], RoiArea.prototype, "mapSource", void 0);
__decorate([
    Prop()
], RoiArea.prototype, "zoneId", void 0);
__decorate([
    Prop()
], RoiArea.prototype, "twinRoi", void 0);
__decorate([
    Prop()
], RoiArea.prototype, "slectValue", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], RoiArea.prototype, "roiDisabled", void 0);
__decorate([
    Watch('rtspUrl')
], RoiArea.prototype, "onchangeRtspUrl", null);
__decorate([
    Watch('slectValue', { immediate: true })
], RoiArea.prototype, "changeZoneList", null);
__decorate([
    Watch('roiType', { immediate: true })
], RoiArea.prototype, "activeTabChange", null);
__decorate([
    Watch('activeTask', { immediate: true })
], RoiArea.prototype, "activeTaskChange", null);
__decorate([
    Watch('complete', { immediate: true })
], RoiArea.prototype, "changeComplete", null);
__decorate([
    Watch('paintState')
], RoiArea.prototype, "onChangePaintState", null);
RoiArea = __decorate([
    Component({
        name: 'RoiArea',
        components: {
            'st-video-drawer': VideoDrawer,
            'st-roi-data-item': RoiDataItem,
            'st-roi-map-item': DrawMapMap,
            'st-draw-roi-map': DrawRoiMap,
            MapDarwer,
            mapUtil,
        },
        i18n: {
            messages: {
                en: {
                    roiArea: 'ROI Area',
                    roiAreaText: 'please add ROI area',
                    lineText: 'please draw a line',
                    frameText: 'please add at least 3 body frame',
                    roiTip: 'Are you sure to delete this ROI?',
                    tip: 'Tips',
                    confirm: 'confirm',
                    cancel: 'cancel',
                    mostRoi: 'A single ROI can draw a maximum of nine edges',
                },
                zh: {
                    roiArea: 'ROI 区域',
                    roiAreaText: '请添加ROI区域',
                    lineText: '请绘制一条线',
                    frameText: '请添加至少3个人体框架',
                    roiTip: '确认删除该ROI吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    mostRoi: '单个ROI 最多只能绘制9条边',
                },
            },
        },
    })
], RoiArea);
export default RoiArea;
